import React from 'react';

import styles from './ButtonsGroup.scss';

type Props = {
  children: React.ReactNode[];
};

function ButtonsGroup(props: Props) {
  return <div className={styles.group}>{props.children}</div>;
}

export default ButtonsGroup;
